import {ReactElement} from 'react';

import {useExternalFilterBridge} from '../../../../hooks/useExternalFilterBridge';
import {FormToDataGridConnectorProps} from '../../../../types/FormToDataGridConnectorProps';

export type CustomFiltersPanelProps = {
  filterComponent: (props: FormToDataGridConnectorProps) => ReactElement;
};

/**
 * Renders the `filterComponent` render-prop function inside the sidebar filter panel.
 *
 * Delegates store↔filter bridging to `useExternalFilterBridge`.
 *
 * @see ExternalFiltersPortal — equivalent component for portal-based external rendering
 */
export function CustomFiltersPanel(props: CustomFiltersPanelProps) {
  const {values, onChange} = useExternalFilterBridge();

  const FilterComponent = props.filterComponent;

  return (
    <div className="flex flex-col gap-3 p-4 overflow-y-auto h-full">
      <FilterComponent values={values} onChange={onChange} />
    </div>
  );
}
